<template>
    <AdminLayout>
        <Head title="Erinnerungen Einstellungen" />

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6">
                        <h2 class="text-2xl font-semibold mb-6">Erinnerungen Einstellungen</h2>

                        <form @submit.prevent="submitForm" class="space-y-6">
                            <div>
                                <label for="title" class="block font-semibold mb-2">Titel:</label>
                                <InputText
                                    id="title"
                                    v-model="form.title"
                                    class="w-full"
                                    :class="{ 'p-invalid': form.errors.title }"
                                    placeholder="Geben Sie den Titel ein..."
                                    @input="form.clearErrors('title')"
                                    @blur="validateTitle"
                                />
                                <small class="p-error" v-if="form.errors.title">{{ form.errors.title }}</small>
                            </div>

                            <div>
                                <label for="body" class="block font-semibold mb-2">Nachricht:</label>
                                <Textarea
                                    id="body"
                                    v-model="form.body"
                                    rows="10"
                                    class="w-full"
                                    :class="{ 'p-invalid': form.errors.body }"
                                    placeholder="Geben Sie die Nachricht ein..."
                                    @input="form.clearErrors('body')"
                                    @blur="validateBody"
                                />
                                <small class="p-error" v-if="form.errors.body">{{ form.errors.body }}</small>
                            </div>

                            <!-- Variable Reference -->
                            <div class="bg-gray-50 p-4 rounded border border-gray-200">
                                <h3 class="font-semibold mb-3 text-gray-700">Verfügbare Variablen:</h3>
                                <div class="grid grid-cols-2 gap-3 text-sm">
                                    <div>
                                        <span class="font-mono bg-white px-2 py-1 rounded border border-gray-300">{vorname}</span>
                                        <span class="text-gray-600 ml-2">Vorname</span>
                                    </div>
                                    <div>
                                        <span class="font-mono bg-white px-2 py-1 rounded border border-gray-300">{nachname}</span>
                                        <span class="text-gray-600 ml-2">Nachname</span>
                                    </div>
                                    <div>
                                        <span class="font-mono bg-white px-2 py-1 rounded border border-gray-300">{vollstaendiger_name}</span>
                                        <span class="text-gray-600 ml-2">Vollständiger Name</span>
                                    </div>
                                    <div>
                                        <span class="font-mono bg-white px-2 py-1 rounded border border-gray-300">{email}</span>
                                        <span class="text-gray-600 ml-2">E-Mail-Adresse</span>
                                    </div>
                                </div>
                                <p class="text-xs text-gray-500 mt-3">
                                    Diese Variablen werden beim Senden automatisch mit den Kundendaten ersetzt.
                                </p>
                            </div>

                            <div class="flex justify-end gap-2">
                                <Button
                                    label="Speichern"
                                    type="submit"
                                    icon="pi pi-save"
                                    :loading="form.processing"
                                    :disabled="form.processing"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </AdminLayout>
</template>

<script setup>
import AdminLayout from '../../../../Layouts/AdminLayout.vue';
import { Head, useForm } from '@inertiajs/inertia-vue3';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import { useToast } from 'primevue/usetoast';

const toast = useToast();

const props = defineProps({
    settings: {
        type: Object,
        default: () => ({
            title: '',
            body: ''
        })
    }
});

const form = useForm({
    title: props.settings.title || '',
    body: props.settings.body || '',
});

const validateTitle = () => {
    if (!form.title || form.title.trim() === '') {
        form.setError('title', 'Titel ist erforderlich');
    }
};

const validateBody = () => {
    if (!form.body || form.body.trim() === '') {
        form.setError('body', 'Nachricht ist erforderlich');
    }
};

const submitForm = () => {
    // Frontend validation
    form.clearErrors();

    let hasErrors = false;

    if (!form.title || form.title.trim() === '') {
        form.setError('title', 'Titel ist erforderlich');
        hasErrors = true;
    }

    if (!form.body || form.body.trim() === '') {
        form.setError('body', 'Nachricht ist erforderlich');
        hasErrors = true;
    }

    if (hasErrors) {
        return;
    }

    form.post(route('admin.alerts.settings.update'), {
        preserveScroll: true,
        onSuccess: () => {
            toast.add({
                severity: 'success',
                summary: 'Einstellungen erfolgreich aktualisiert',
                life: 5000,
            });
        },
    });
};
</script>
